import { render, staticRenderFns } from "./shopCart.vue?vue&type=template&id=253b914c"
import script from "./shopCart.vue?vue&type=script&lang=js"
export * from "./shopCart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports